import classes from './fieldByType.module.css';

const FloatTypeField = ({ item, selectItem, disabled, units, setNewSelectItem }) => {
  return (
    <div className={classes.numberBlock}>
      <input
        type={'number'}
        onWheel={(e) => e.target.blur()}
        step={0.5}
        className={classes.input}
        value={selectItem?.value}
        onChange={(e) =>
          setNewSelectItem({ value: e.target.value ?? ' ', setting: item.setting[0] ?? {} })
        }
        disabled={disabled}
      />
      <div>{units?.find((val) => val.id == item.setting.unit)?.name}</div>
    </div>
  );
};

export default FloatTypeField;
